




































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppFormCard from '@/components/AppFormCard.vue'
import AppTextInput from '@/components/AppTextInput.vue'

import { Common } from '@/mixins'

@Component({
  components: {
    AppFormCard,
    AppTextInput
  }
})
export default class extends Mixins(Common) {
  @Prop() readonly refundBankCode!: string
  @Prop() readonly refundBankAccountHolderName!: string
  @Prop() readonly refundBankAccount!: string
}
